module.exports = __webpack_public_path__ + "img/BB_logo_White-Copy.7f97e325.png";